import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Icon } from "@iconify/react";
import { Stack, Button, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { currentBoxSize } from "../../../../store/reducers/pdfeditor/toolsModificationSlice"; 
import { updateCoordinate } from "../../../../store/reducers/pdfeditor/pdfCoordinatesSlice";

const BoxHeight = ({settedBoxHeight}) => {

  const [boxSize, setBoxSize] = useState({ height: 15, width: 15 });
  const { updatedBoxSize, currVariable } = useSelector(
    (state) => state.toolsModification
  );
  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(currentBoxSize(boxSize));
  }, [boxSize]);

  useEffect(() => {
    if (!updatedBoxSize) return;
    setBoxSize(updatedBoxSize);
  }, [updatedBoxSize]);

  const handleChange = (e) => {
    let name = e.target.name;
    let value = Number(e.target.value);
    if (value >= 0 && !currVariable?.variable) {
      setBoxSize({ ...boxSize, [name]: value });
    } else if (value >= 0 && currVariable?.variable) {
      let data = { [name]: value };
      dispatch(
        updateCoordinate({ id: currVariable?.variable, newValue: data })
      );
      setBoxSize({ ...boxSize, [name]: value });
    }
  };

  return (
    <Wrapper style={{position:'relative', left:'120px',width:'40px'}} >
    {/* <Wrapper style={{position:'relative', left:'98px',top:'8px',width:'40px'}} > */}
        <input
          type='number'
          value={settedBoxHeight || boxSize.height}
          onChange={handleChange}
          name='height'
          autoFocus
          style={inputStyle}
        />
    </Wrapper>
  );
};

export default BoxHeight;
const inputStyle = {
    width: "100%",
    height: "33px",
    borderRadius:'5px',
    // border:'2px solid black'
  };
const Wrapper = styled.div`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .size-display {
    display: flex;
    align-items: center;
    width: auto;
  }
  p {
    font-size: 12px;
  }
`;
